import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import DataLoader from 'dataloader';
import { Store } from 'libx';
import pick from 'lodash/pick';
import { action } from 'mobx';
import * as path from 'path';
import env from '../misc/env';
import { getFeatureToggleClient } from '../misc/featureToggles';
import { BackgroundDataLoader } from '../utils/bufferUtil';
import { pageActivityStream } from '../utils/domUtil';
import { extractMessageFromError } from '../utils/errorUtil';
import { createIamAPI } from './API';
import Member from './Member';

/**
 * Manages members, which are users that belong to a workspace.
 */
var MemberStore = /*#__PURE__*/function (_Store) {
  function MemberStore() {
    var _this;
    _classCallCheck(this, MemberStore);
    _this = _callSuper(this, MemberStore, arguments);
    /**
     * Members collection.
     */
    _this.members = _this.collection({
      model: Member,
      // We don't use the Member `id` for anything, always workspace + user Public ID.
      getDataId: function getDataId(data) {
        return "".concat(data.workspace_id, "/").concat(data.user_public_id);
      },
      getModelId: function getModelId(model) {
        return "".concat(model.workspaceId, "/").concat(model.userPublicId);
      }
    });
    /**
     * Used to compute a cache key from params.
     */
    _this._publicCacheKeyFn = function (params) {
      return "".concat(params.workspace_id, "/").concat(params.user_public_id);
    };
    /**
     * IAM API.
     */
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    /**
     * Member loader cache.
     */
    _this.memberLoaderCache = new Map();
    /**
     * Data loader.
     */
    _this.memberPublicIdLoader = new DataLoader(_this._fetchManyByPublicId.bind(_this), {
      cacheKeyFn: _this._publicCacheKeyFn,
      cacheMap: _this.memberLoaderCache
    });
    _this.bufferUtil = new BackgroundDataLoader(pageActivityStream(), _this.rootStore.authStore.stale$);
    _this.bufferUtil.start(function (x) {
      return _this.fetchManyByPublicId(x);
    });
    return _this;
  }

  /**
   * Returns a member from the collection matching the workspace and user IDs.
   *
   * @param {string} workspaceId
   * @param {string} userId
   */
  _inherits(MemberStore, _Store);
  return _createClass(MemberStore, [{
    key: "forWorkspaceAndUserId",
    value: function forWorkspaceAndUserId(workspaceId, userId) {
      var workspace = this.rootStore.workspaceStore.workspaces.find(function (x) {
        return x.slug === workspaceId || x.id === workspaceId;
      });
      if (!workspace) {
        return null;
      }
      return this.members.find(function (x) {
        return x.workspaceId === workspace.id && x.userId === userId;
      }) || null;
    }

    /**
     * Returns a member from the collection matching the workspace and user IDs.
     *
     * @param {string} workspaceId
     * @param {string} userPublicId
     */
  }, {
    key: "forWorkspaceAndUserPublicId",
    value: function forWorkspaceAndUserPublicId(workspaceId, userPublicId) {
      var workspace = this.rootStore.workspaceStore.workspaces.find(function (x) {
        return x.slug === workspaceId || x.id === workspaceId;
      });
      if (!workspace) {
        return null;
      }
      return this.members.find(function (x) {
        return x.workspaceId === workspace.id && x.userPublicId === userPublicId;
      }) || null;
    }

    /**
     * Gets (or inits) a member, fetches it in the background if needed, and returns
     * it.
     *
     * @param {{ workspace_id: string, user_id: string, user_public_id: string}} props
     */
  }, {
    key: "setAndFetch",
    value: function setAndFetch(props) {
      var _this2 = this;
      if (Array.isArray(props)) {
        return props.map(function (x) {
          return _this2.setAndFetch(x);
        });
      }
      if (!props.workspace_id) {
        console.warn('MemberStore.setAndFetch: props.workspace_id is required.');
        return null;
      }
      if (!props.user_public_id) {
        console.warn('MemberStore.setAndFetch: props.user_public_id is required.');
        return null;
      }
      var alreadyCached = this.memberLoaderCache.has(this._publicCacheKeyFn(props));
      var bufferSetAndFetch = getFeatureToggleClient().variation('WebCommons.MemberStoreIdQueryBuffer', false);
      if (bufferSetAndFetch) {
        this.bufferUtil.load({
          workspace_id: props.workspace_id,
          user_public_id: props.user_public_id
        });
      } else {
        this.fetchByPublicId({
          workspace_id: props.workspace_id,
          user_public_id: props.user_public_id
        });
      }
      var member = this._getOrInitMemberForParamsByPublicId(props);
      if (alreadyCached) {
        // The member has already been requested, so don't
        // assign any props to it
        return member;
      }
      return member.set(props, {
        parse: true,
        stripUndefined: true
      });
    }

    /**
     * Gets or inits a member, fetches it if needed, and returns it, all without a user_id.
     * @param {{ workspace_id: string, user_public_id: string }} props
     */
  }, {
    key: "setAndFetchByPublicId",
    value: function setAndFetchByPublicId(props) {
      var _this3 = this;
      if (Array.isArray(props)) {
        return props.map(function (x) {
          return _this3.setAndFetch(x);
        });
      }
      if (!props.workspace_id) {
        console.warn('MemberStore.setAndFetch: props.workspace_id is required.');
        return null;
      }
      if (!props.user_public_id) {
        console.warn('MemberStore.setAndFetch: props.user_public_id is required.');
        return null;
      }
      var alreadyCached = this.memberLoaderCache.has(this._publicCacheKeyFn(props));
      this.fetchByPublicId({
        workspace_id: props.workspace_id,
        user_public_id: props.user_public_id
      });
      var member = this._getOrInitMemberForParamsByPublicId(props);
      if (alreadyCached) {
        // The member has already been requested, so don't
        // assign any props to it
        return member;
      }
      return member.set(props, {
        parse: true,
        stripUndefined: true
      });
    }

    /**
     * Queries for members.
     *
     * @param {*} query
     */
  }, {
    key: "find",
    value: (function () {
      var _find = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.members.find(query).then(function (result) {
                if (query.populate === false) {
                  result.data.forEach(function (x) {
                    // we know these will be empty if populate is false so delete them until we fix IAM
                    delete x.roles;
                    delete x.skills;
                    delete x.computed_permissions;
                  });
                }
                return _objectSpread(_objectSpread({}, result), {}, {
                  data: _this4.members.set(result.data)
                });
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function find(_x) {
        return _find.apply(this, arguments);
      }
      return find;
    }()
    /**
     * Searches for members.
     *
     * @param {*} query
     */
    )
  }, {
    key: "search",
    value: (function () {
      var _search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
        var _this5 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.members.search(query).then(function (result) {
                if (query.populate === false) {
                  result.data.forEach(function (x) {
                    // we know these will be empty if populate is false so delete them until we fix IAM
                    delete x.roles;
                    delete x.skills;
                    delete x.computed_permissions;
                  });
                }
                return _objectSpread(_objectSpread({}, result), {}, {
                  data: _this5.members.set(result.data)
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function search(_x2) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
    /**
     * Fetch a single member by publicId from the API (or cache).
     *
     * @param {*} params
     */
    )
  }, {
    key: "fetchByPublicId",
    value: (function () {
      var _fetchByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!params.workspace_id) {
                console.warn(new Error('MemberStore.fetchByPublicId missing workspace_id'));
              }
              return _context3.abrupt("return", this.memberPublicIdLoader.load(params));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchByPublicId(_x3) {
        return _fetchByPublicId.apply(this, arguments);
      }
      return fetchByPublicId;
    }()
    /**
     * Fetches many members from the API using public ID (or cache)
     * @param {*} ids
     */
    )
  }, {
    key: "fetchManyByPublicId",
    value: (function () {
      var _fetchManyByPublicId2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ids) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (ids.some(function (x) {
                return !x.workspace_id;
              })) {
                console.warn(new Error('ARGH!'));
              }
              return _context4.abrupt("return", this.memberPublicIdLoader.loadMany(ids));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchManyByPublicId(_x4) {
        return _fetchManyByPublicId2.apply(this, arguments);
      }
      return fetchManyByPublicId;
    }()
    /**
     * Creates a workspace member.
     * @param {*} data
     */
    )
  }, {
    key: "create",
    value: function create(data) {
      return this.api.members.create(data).then(this.members.set);
    }

    /**
     * Updates a member.
     *
     * @param {*} params
     * @param {*} data
     */
  }, {
    key: "update",
    value: (function () {
      var _update = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params, data) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.api.members.update(params, data).then(this.members.set));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function update(_x5, _x6) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
    /**
     * Updates a member.
     *
     * @param {*} params
     * @param {*} data
     */
    )
  }, {
    key: "updateByPublicId",
    value: (function () {
      var _updateByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params, data) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.api.members.updateByPublicId(params, data).then(this.members.set));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateByPublicId(_x7, _x8) {
        return _updateByPublicId.apply(this, arguments);
      }
      return updateByPublicId;
    }()
    /**
     * Updates a member's last_login date.
     *
     */
    )
  }, {
    key: "updateLastLogin",
    value: (function () {
      var _updateLastLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(workspace_id) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.api.members.updateLastLogin(workspace_id).then(this.members.set));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateLastLogin(_x9) {
        return _updateLastLogin.apply(this, arguments);
      }
      return updateLastLogin;
    }()
    /**
     * Updates a member's last_seen date.
     *
     */
    )
  }, {
    key: "updateLastSeen",
    value: (function () {
      var _updateLastSeen = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(workspace_id) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.api.members.updateLastSeen(workspace_id).then(this.members.set));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateLastSeen(_x10) {
        return _updateLastSeen.apply(this, arguments);
      }
      return updateLastSeen;
    }())
  }, {
    key: "isValidFile",
    value: function isValidFile(file) {
      var maxSize = 1024 * 1024 * 10;
      var ext = path.extname(file.name);
      var isSupported = /(jpe?g|png)/i.test(ext);
      if (!isSupported) {
        this.rootStore.flashMessageStore.create({
          type: 'error',
          message: 'We only support PNG, JPEG and JPG files for profile pictures.'
        }).autoDismiss();
        return false;
      }
      if (maxSize < file.size) {
        this.rootStore.flashMessageStore.create({
          type: 'error',
          message: "Max image size is 10mb."
        }).autoDismiss();
        return false;
      }
      return true;
    }

    /**
     * Uploads a new avatar for the member.
     *
     * @param {*} params
     * @param {*} file
     */
  }, {
    key: "changeAvatarByPublicId",
    value: (function () {
      var _changeAvatarByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(params, file) {
        var isValidFile, msg;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              isValidFile = this.isValidFile(file);
              if (isValidFile) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return");
            case 3:
              msg = this.rootStore.flashMessageStore.create({
                inProgress: true,
                message: 'Uploading new profile picture...'
              });
              _context9.next = 6;
              return this.api.members.changeAvatarByPublicId(params, file).then(action(this.members.set)).then(action(function () {
                msg.done('Successfully changed profile picture!').autoDismiss();
              })).catch(action(function (err) {
                msg.failed(extractMessageFromError(err));
                console.error(err);
              }));
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function changeAvatarByPublicId(_x11, _x12) {
        return _changeAvatarByPublicId.apply(this, arguments);
      }
      return changeAvatarByPublicId;
    }()
    /**
     * Updates the members permissions.
     * @param {*} params
     * @param {*} permissions
     */
    )
  }, {
    key: "updatePermissions",
    value: (function () {
      var _updatePermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(params, permissions) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.update(params, {
                member_permissions: permissions
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function updatePermissions(_x13, _x14) {
        return _updatePermissions.apply(this, arguments);
      }
      return updatePermissions;
    }()
    /**
     * Updates the member permissions by public id.
     * @param {{ user_id: string, workspace_id: string }} params
     * @param {Object.<string, string>} permissions
     */
    )
  }, {
    key: "updatePermissionsByPublicId",
    value: (function () {
      var _updatePermissionsByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(params, permissions) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.updateByPublicId(params, {
                member_permissions: permissions
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function updatePermissionsByPublicId(_x15, _x16) {
        return _updatePermissionsByPublicId.apply(this, arguments);
      }
      return updatePermissionsByPublicId;
    }())
  }, {
    key: "checkTermsOfUseAcceptance",
    value: function () {
      var _checkTermsOfUseAcceptance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(workspaceId) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.api.termsOfUse.checkAcceptance(workspaceId).then(function (acceptance) {
                return acceptance.accepted;
              }));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function checkTermsOfUseAcceptance(_x17) {
        return _checkTermsOfUseAcceptance.apply(this, arguments);
      }
      return checkTermsOfUseAcceptance;
    }()
  }, {
    key: "acceptLatestTermsOfUse",
    value: function () {
      var _acceptLatestTermsOfUse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(workspaceId) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.api.termsOfUse.acceptLatest(workspaceId));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function acceptLatestTermsOfUse(_x18) {
        return _acceptLatestTermsOfUse.apply(this, arguments);
      }
      return acceptLatestTermsOfUse;
    }()
    /**
     * Adds a role to a member by public id.
     *
     * @param {*} params
     * @param roleId
     */
  }, {
    key: "addRoleByPublicId",
    value: (function () {
      var _addRoleByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params, roleId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.api.members.addRoleByPublicId(_objectSpread({
                role_id: roleId
              }, params)).then(this.members.set));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function addRoleByPublicId(_x19, _x20) {
        return _addRoleByPublicId.apply(this, arguments);
      }
      return addRoleByPublicId;
    }()
    /**
     * Adds a skill to a member by public id.
     *
     * @param {*} params
     * @param {*} skillId
     */
    )
  }, {
    key: "addSkillByPublicId",
    value: (function () {
      var _addSkillByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params, skillId) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this.api.members.addSkillByPublicId(_objectSpread({
                skill_id: skillId
              }, params)).then(this.members.set));
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function addSkillByPublicId(_x21, _x22) {
        return _addSkillByPublicId.apply(this, arguments);
      }
      return addSkillByPublicId;
    }()
    /**
     * Removes a role from a member by public id.
     *
     * @param {R} params
     * @param {*} roleId
     */
    )
  }, {
    key: "removeRoleByPublicId",
    value: (function () {
      var _removeRoleByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params, roleId) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this.api.members.removeRoleByPublicId(_objectSpread({
                role_id: roleId
              }, params)).then(this.members.set));
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function removeRoleByPublicId(_x23, _x24) {
        return _removeRoleByPublicId.apply(this, arguments);
      }
      return removeRoleByPublicId;
    }()
    /**
     * Removes a skill from a member by public id.
     *
     * @param {R} params
     * @param {*} skillId
     */
    )
  }, {
    key: "removeSkillByPublicId",
    value: (function () {
      var _removeSkillByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(params, skillId) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", this.api.members.removeSkillByPublicId(_objectSpread({
                skill_id: skillId
              }, params)).then(this.members.set));
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function removeSkillByPublicId(_x25, _x26) {
        return _removeSkillByPublicId.apply(this, arguments);
      }
      return removeSkillByPublicId;
    }()
    /**
     * Implementation of fetching many users. Used by the dataloader.
     *
     * @private
     * @param {*} ids
     */
    )
  }, {
    key: "_fetchManyByPublicId",
    value: (function () {
      var _fetchManyByPublicId3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(ids) {
        var _this6 = this;
        var membersToFetch, results;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!(ids.length === 0)) {
                _context18.next = 2;
                break;
              }
              return _context18.abrupt("return", []);
            case 2:
              membersToFetch = new Map();
              ids.forEach(function (params) {
                var member = _this6._getOrInitMemberForParamsByPublicId(params);
                if (member) {
                  membersToFetch.set(params.workspace_id + params.user_public_id, member);
                }
              });
              _context18.next = 6;
              return this.api.members.getMany(ids);
            case 6:
              results = _context18.sent;
              results.forEach(function (item, index) {
                if (!item) {
                  // If the user is not found now, does not mean it won't be found later.
                  _this6.memberPublicIdLoader.clear(ids[index]);
                  _this6.members.remove(ids[index]);
                } else {
                  var target = membersToFetch.get(item.workspace_id + item.user_public_id);
                  if (target) {
                    target.set(item, {
                      parse: true,
                      stripUndefined: true
                    });
                  }
                }
              });
              return _context18.abrupt("return", results.map(function (r) {
                return r ? _this6.forWorkspaceAndUserPublicId(r.workspace_id, r.user_public_id) : undefined;
              }));
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function _fetchManyByPublicId(_x27) {
        return _fetchManyByPublicId3.apply(this, arguments);
      }
      return _fetchManyByPublicId;
    }())
  }, {
    key: "_getOrInitMemberForParamsByPublicId",
    value: function _getOrInitMemberForParamsByPublicId(params) {
      params = pick(params, ['workspace_id', 'user_public_id']);
      var getOrInitMember = params.workspace_id && params.user_public_id ? this.forWorkspaceAndUserPublicId(params.workspace_id, params.user_public_id) || this.members.set(params) : null;
      return getOrInitMember;
    }
  }]);
}(Store);
export { MemberStore as default };
//# sourceMappingURL=MemberStore.js.map
